import { FormattedMessage } from 'react-intl';
import { useStreaming } from 'src/context/StreamingContext';
import { useIsMobile } from 'src/hooks/useIsMobile';
import { useSourcesStore } from 'src/hooks/useSourcesStore';
import AsideNewChat from '../AsideNewChat/AsideNewChat';
import Header from '../Chat/Header/Header';
import Loading from '../Loading/Loading';
import Sources from '../Sources/Sources';

import './Sidebar.sass';

interface SidebarProps {
	handleClose: () => void;
	show: boolean;
}

const Sidebar = ({ handleClose, show }: SidebarProps) => {
	const { sources, hasSources, hasInternetSources, messageId, internetSources } = useSourcesStore();
	const { streamInfo } = useStreaming();
	const { isWriting } = streamInfo;
	const isMobile = useIsMobile();
	return (
		<aside id="sidebar" className={`sidebar-content ${show ? 'show' : 'hide'}`}>
			{(!isWriting || isMobile) && <Header handleClose={handleClose} />}
			{hasSources || hasInternetSources ? (
				<section id="sources">
					{isWriting && <Loading text="typing-text.text-2" />}
					<div className="sources-list">
						{messageId && hasSources && <Sources sources={sources} messageId={messageId} internet={false} />}
						{hasInternetSources && (
							<>
								<h3 className="internet-sources-message">
									<FormattedMessage id="internet-sources" />
								</h3>
								{messageId && <Sources sources={internetSources} messageId={messageId} internet={true} />}
							</>
						)}
					</div>
				</section>
			) : (
				<AsideNewChat handleClose={handleClose} />
			)}
		</aside>
	);
};

export default Sidebar;
